import { fieldStyle } from '../../primitives';
import { Field } from '../../primitives/Field';
import { TWO_COLUMN_GRID } from '../../primitives/two-column-grid';

import { TREE_REPLACEMENT_LIMITS as LIMITS } from './tree-replacement-form';
import type { TreeReplacementFormFieldsProps } from './TreeReplacementFormFields';

export function TreeReplacementContactFields({
  values,
  errors,
  onChange,
}: Omit<TreeReplacementFormFieldsProps, 'includeContact'>) {
  return (
    <>
      <div style={TWO_COLUMN_GRID}>
        <Field label="First name" required error={errors.firstName}>
          <input
            value={values.firstName}
            maxLength={LIMITS.name}
            onChange={(e) => onChange({ firstName: e.target.value })}
            style={fieldStyle(errors.firstName ? 'error' : undefined)}
          />
        </Field>
        <Field label="Last name" error={errors.lastName}>
          <input
            value={values.lastName}
            maxLength={LIMITS.name}
            onChange={(e) => onChange({ lastName: e.target.value })}
            style={fieldStyle(errors.lastName ? 'error' : undefined)}
          />
        </Field>
      </div>
      <div style={TWO_COLUMN_GRID}>
        <Field label="Email" error={errors.email}>
          <input
            type="email"
            value={values.email}
            maxLength={LIMITS.email}
            onChange={(e) => onChange({ email: e.target.value })}
            style={fieldStyle(errors.email ? 'error' : undefined)}
          />
        </Field>
        <Field label="Phone" error={errors.phone}>
          <input
            type="tel"
            value={values.phone}
            maxLength={LIMITS.phone}
            onChange={(e) => onChange({ phone: e.target.value })}
            style={fieldStyle(errors.phone ? 'error' : undefined)}
          />
        </Field>
      </div>
    </>
  );
}
